import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ActionBar, Button, Icon, Text, Time } from '@feathr/components';
import { TimeFormat } from '@feathr/hooks';
import { useUser } from '@feathr/report_components';

import { useEmailConfigurator } from './useEmailConfigurator';

function EmailConfiguratorActionBar(): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { lastSaved, handleSave, isDirty, showConfirmButton } = useEmailConfigurator();
  const user = useUser();

  const buttonText = showConfirmButton ? t('Confirm details') : t('Save changes');
  const buttonType = showConfirmButton ? 'success' : 'primary';
  const buttonPrefix = showConfirmButton ? <FontAwesomeIcon icon={faCircleCheck} /> : <Icon.Save />;
  const buttonDisabled = showConfirmButton ? false : !isDirty;

  return (
    <ActionBar
      left={
        <Flex gap={theme.spacing['2']}>
          <Text.DefaultSemibold>{t('Last saved:')}</Text.DefaultSemibold>
          {lastSaved ? (
            <Time
              format={TimeFormat.longDateTime}
              showTimezone={false}
              timestamp={lastSaved}
              timezone={user.get('timezone')}
            />
          ) : (
            <Text.DefaultRegular>{t('Never')}</Text.DefaultRegular>
          )}
        </Flex>
      }
      right={
        <Button
          disabled={buttonDisabled}
          onClick={handleSave}
          prefix={buttonPrefix}
          type={buttonType}
        >
          {buttonText}
        </Button>
      }
      usePortal={true}
    />
  );
}

export default EmailConfiguratorActionBar;
